import { Exclude, Expose, instanceToPlain, plainToInstance } from "class-transformer";
import * as t from "io-ts";
import { validateJSON, validateJSONNow } from "../web/validation";
import { Entity } from "./entity";

export const SystemProcessExecutionIssueCodec = t.intersection([
  t.type({
    id: t.string,
    systemProcessExecutionId: t.string,
    severity: t.string,
    issueType: t.string,
    message: t.string,
  }),
  t.partial({
    issueKey: t.string,
    details: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export type SystemProcessExecutionIssue = t.TypeOf<typeof SystemProcessExecutionIssueCodec>;

@Exclude()
export class SystemProcessExecutionIssueEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  systemProcessExecutionId!: string;

  @Expose()
  severity!: string;

  @Expose()
  issueType!: string;

  @Expose()
  message!: string;

  // ─────────────────────────────
  // Optional fields
  // ─────────────────────────────

  @Expose()
  issueKey?: string;

  @Expose()
  details?: string;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = "SYSPROCEXECISSUE";

  get displayName(): Readonly<string> {
    return this.id;
  }

  constructor() {}

  static from(value: SystemProcessExecutionIssue): SystemProcessExecutionIssueEntity {
    return plainToInstance(SystemProcessExecutionIssueEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<SystemProcessExecutionIssue> {
    const object = instanceToPlain(this, { excludeExtraneousValues: true });
    return validateJSON(SystemProcessExecutionIssueCodec, object);
  }

  asTypeValue(): SystemProcessExecutionIssue {
    const object = instanceToPlain(this, { excludeExtraneousValues: true });
    return validateJSONNow(SystemProcessExecutionIssueCodec, object);
  }
}
